import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setChoiceGroupSelectionState')(function setChoiceGroupSelectionState(selection) {
    store.choiceGroupSelection = selection;
});
//# sourceMappingURL=setChoiceGroupSelectionState.js.map